import React from "react";
import PropTypes from "prop-types";
import logo from "./img/hh.png";
import jobType from "./types/jobType";

class JobStatus extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isExpanded: false,
    };
  }

  handleKeyPress = (event) => {
    if (event.key === "Enter") {
      this.setState((state) => ({
        isExpanded: !state.isExpanded,
        height: this.inner.clientHeight,
      }));
    }
  };

  handleToggle = (e) => {
    e.preventDefault();
    this.setState((state) => ({
      isExpanded: !state.isExpanded,
      height: this.inner.clientHeight,
    }));
  };

  render() {
    const {
      job: {
        submittedCvs,
        cvsRead,
        candidatesRejected,
        numberOfOffersMade,
        phoneInterviews,
        competencies,
        firstStageInterview,
        secondStageInterview,
        recruiterGuidance,
        numberOfPlacementsMade,
        numberOfPositions,
      },
      avgResponseTime,
    } = this.props;

    const { isExpanded, height } = this.state;
    const currentHeight = isExpanded ? height : 100;

    const applicationStats = {
      "SUBMITTED CV'S": submittedCvs,
      "CV'S READ": cvsRead,
      "CANDIDATES REJECTED": candidatesRejected,
      "OFFERS MADE": numberOfOffersMade,
    };

    const interviewStats = {
      "PHONE INTERVIEWS": phoneInterviews,
      COMPETENCIES: competencies,
      "1ST STAGE INTERVIEW": firstStageInterview,
      "2ND STAGE INTERVIEW": secondStageInterview,
    };

    return (
      <div id="job-status" className="job-status">
        {!!recruiterGuidance && (
          <div className="row guidance-row">
            <div
              className={`col-sm-12 recruiter-guidance ${
                isExpanded ? "is-expanded" : ""
              }`}
              style={{ height: `${currentHeight}px` }}
            >
              <div className="guidance-inner">
                <div
                  className="guidance-message"
                  ref={(c) => {
                    this.inner = c;
                  }}
                >
                  {recruiterGuidance}
                  <div className="guidance-author">
                    <img src={logo} alt="" />
                    <strong>Hiring Hub</strong>
                  </div>
                </div>
              </div>
            </div>
            <div
              role="button"
              className="guidance-button"
              tabIndex={0}
              onClick={this.handleToggle}
              onKeyPress={this.handleKeyPress}
            >
              {`${isExpanded ? "Show less" : "Read more..."}`}
            </div>
          </div>
        )}
        <div className="row">
          <div className="col-xs-6 col-md-6 col-lg-4 applications">
            <h3>APPLICATIONS</h3>
            {Object.keys(applicationStats).map((statKey) => {
              const statValue = applicationStats[statKey];
              return (
                <div className="row" key={statValue}>
                  <div className="col-xs-4 counter">
                    <div className="counter-number">{statValue}</div>
                  </div>
                  <div className="col-xs-8 counter-label">{statKey}</div>
                </div>
              );
            })}
            {numberOfPositions > 1 && (
              <div className="row" key="numberOfPlacementsMade">
                <div className="col-xs-4 counter">
                  <div className="counter-number">{numberOfPlacementsMade}</div>
                </div>
                <div className="col-xs-8 counter-label">PLACEMENTS MADE</div>
              </div>
            )}
          </div>
          <div className="col-xs-6 col-md-6 col-lg-4 interviews">
            <h3>INTERVIEWS</h3>
            {Object.keys(interviewStats).map((statKey) => {
              const statValue = interviewStats[statKey];
              return (
                <div className="row" key={statValue}>
                  <div className="col-xs-4 counter">
                    <div className="counter-number">{statValue}</div>
                  </div>
                  <div className="col-xs-8 counter-label">{statKey}</div>
                </div>
              );
            })}
          </div>
          <div className="col-xs-12 col-md-12 col-lg-4 avg-response">
            <h3>Emp. Avg. Response</h3>
            <div className="response-wrapper">
              <div className="response-inner">
                <i className="fas fa-user-clock" />
                <div className="response-title">
                  Employer average response time
                </div>
                <div className="response-time">
                  {avgResponseTime || "new employer"}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

JobStatus.propTypes = {
  job: jobType.isRequired,
  avgResponseTime: PropTypes.string,
};

JobStatus.defaultProps = {
  avgResponseTime: PropTypes.isNull,
};

export default JobStatus;
